import { UnitFieldCond } from "common/api/citajteo/dl_group/citajteo_group";
import { FCondItem } from "./DlGroupForm";
import { UnitFieldValName } from "constant/dl_unit/dl_unit_field.constant";

export function fCondArrFormat(fCond: UnitFieldCond): FCondItem[] {
  const fCondItems: FCondItem[] = Object.entries(fCond).map(
    (fieldNameVal: [UnitFieldValName, string]) => {
      return {
        fieldName: fieldNameVal[0],
        fieldValue: fieldNameVal[1],
      };
    },
  );

  return fCondItems;
}

export function fCondObFormat(fCondItems: FCondItem[]): UnitFieldCond {
  const res: UnitFieldCond = {};

  for (let i = 0; i < fCondItems.length; i++) {
    const { fieldName, fieldValue } = fCondItems[i];
    res[fieldName] = fieldValue;
  }

  return res;
}
